import React from 'react';

import Avatar from '@adsk/alloy-react-avatar';
import { AVATAR_SIZES } from '@adsk/alloy-react-avatar/es/constants';
import { MenuItem } from '@adsk/alloy-react-dropdown';

import { ItemWithImage } from '../../helpers/filters';

export const DropdownItemWithImage = ({
  item,
  ...props
}: {
  item: ItemWithImage;
}) => (
  <MenuItem
    {...props}
    text={item.label}
    renderLeftComponent={() => (
      <Avatar
        size={AVATAR_SIZES.MEDIUM_24}
        image={item.imageUrl}
        style={{ marginRight: '8px' }}
      />
    )}
  />
);
